import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'youtubeCategory',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  getURL: 'appId/areaId/appCategory',
  sessionParams: ['appId', 'areaId'],
  emptyMessage: "You don't have categories, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the category.',
    },
  ],
};
